export default __webpack_public_path__ + "static/media/widget_watchbox_vpmesc5_sell.10fe3ff6.mp3";